import { create } from "zustand"
import api from "../services/api"

const dashboardPeriodoChaveGerar = (cDateFrom = "", cDateTo = "", nDays = 0) => {
  if (cDateFrom && cDateTo) return `${cDateFrom}|${cDateTo}`
  return `days:${nDays || 0}`
}

const dashboardTicketsPeriodoChaveGerar = (cInicial = "", cFinal = "", nCompanyId = "") =>
  `${cInicial}|${cFinal}|${nCompanyId}`

const removerChavePendente = (oMapa, cChave) => {
  const { [cChave]: _, ...oRestante } = oMapa
  return oRestante
}

export const useDashboardStore = create((set, get) => ({
  nGeracaoCache: 0,
  oPrincipalPorChave: {},
  oTicketsUsuariosPorChave: {},
  oTicketsDiaPorChave: {},
  lPrincipalInvalido: true,
  lTicketsUsuariosInvalido: true,
  lTicketsDiaInvalido: true,
  oBuscaPrincipalPendentePorChave: {},
  oBuscaTicketsUsuariosPendentePorChave: {},
  oBuscaTicketsDiaPendentePorChave: {},

  reiniciar: () =>
    set((oEstado) => ({
      nGeracaoCache: oEstado.nGeracaoCache + 1,
      oPrincipalPorChave: {},
      oTicketsUsuariosPorChave: {},
      oTicketsDiaPorChave: {},
      lPrincipalInvalido: true,
      lTicketsUsuariosInvalido: true,
      lTicketsDiaInvalido: true,
      oBuscaPrincipalPendentePorChave: {},
      oBuscaTicketsUsuariosPendentePorChave: {},
      oBuscaTicketsDiaPendentePorChave: {},
    })),

  invalidarTudo: () => get().reiniciar(),

  principalObterDoCache: ({ date_from: cDateFrom, date_to: cDateTo, days: nDays } = {}) => {
    const cChave = dashboardPeriodoChaveGerar(cDateFrom, cDateTo, nDays || 0)
    const oEstado = get()
    if (!oEstado.lPrincipalInvalido && oEstado.oPrincipalPorChave[cChave]) {
      return oEstado.oPrincipalPorChave[cChave]
    }
    return null
  },

  ticketsUsuariosObterDoCache: ({ initialDate: cInicial, finalDate: cFinal, companyId: nCompanyId } = {}) => {
    const cChave = dashboardTicketsPeriodoChaveGerar(cInicial, cFinal, nCompanyId)
    const oEstado = get()
    if (!oEstado.lTicketsUsuariosInvalido && oEstado.oTicketsUsuariosPorChave[cChave]) {
      return oEstado.oTicketsUsuariosPorChave[cChave]
    }
    return null
  },

  ticketsDiaObterDoCache: ({ initialDate: cInicial, finalDate: cFinal, companyId: nCompanyId } = {}) => {
    const cChave = dashboardTicketsPeriodoChaveGerar(cInicial, cFinal, nCompanyId)
    const oEstado = get()
    if (!oEstado.lTicketsDiaInvalido && oEstado.oTicketsDiaPorChave[cChave]) {
      return oEstado.oTicketsDiaPorChave[cChave]
    }
    return null
  },

  principalBuscar: async ({ date_from: cDateFrom, date_to: cDateTo, days: nDays, force: lForcar = false } = {}) => {
    const cChave = dashboardPeriodoChaveGerar(cDateFrom, cDateTo, nDays || 0)
    const oEstado = get()

    if (!lForcar && !oEstado.lPrincipalInvalido && oEstado.oPrincipalPorChave[cChave]) {
      return oEstado.oPrincipalPorChave[cChave]
    }

    if (oEstado.oBuscaPrincipalPendentePorChave[cChave]) {
      return oEstado.oBuscaPrincipalPendentePorChave[cChave]
    }

    const oParams = {}
    if (nDays > 0) oParams.days = nDays
    if (cDateFrom) oParams.date_from = cDateFrom
    if (cDateTo) oParams.date_to = cDateTo

    const nGeracao = oEstado.nGeracaoCache
    const oPromessa = api
      .get("/dashboard", { params: oParams })
      .then(({ data }) => {
        if (get().nGeracaoCache !== nGeracao) {
          return { counters: {}, attendants: [] }
        }
        set((oAtual) => ({
          oPrincipalPorChave: { ...oAtual.oPrincipalPorChave, [cChave]: data },
          lPrincipalInvalido: false,
          oBuscaPrincipalPendentePorChave: removerChavePendente(oAtual.oBuscaPrincipalPendentePorChave, cChave),
        }))
        return data
      })
      .catch((oErro) => {
        if (get().nGeracaoCache === nGeracao) {
          set((oAtual) => ({
            oBuscaPrincipalPendentePorChave: removerChavePendente(oAtual.oBuscaPrincipalPendentePorChave, cChave),
          }))
        }
        throw oErro
      })

    set((oAtual) => ({
      oBuscaPrincipalPendentePorChave: { ...oAtual.oBuscaPrincipalPendentePorChave, [cChave]: oPromessa },
    }))
    return oPromessa
  },

  principalObter: async (oParametros) => get().principalBuscar(oParametros),

  ticketsUsuariosBuscar: async ({
    initialDate: cInicial,
    finalDate: cFinal,
    companyId: nCompanyId,
    force: lForcar = false,
  } = {}) => {
    const cChave = dashboardTicketsPeriodoChaveGerar(cInicial, cFinal, nCompanyId)
    const oEstado = get()

    if (!lForcar && !oEstado.lTicketsUsuariosInvalido && oEstado.oTicketsUsuariosPorChave[cChave]) {
      return oEstado.oTicketsUsuariosPorChave[cChave]
    }

    if (oEstado.oBuscaTicketsUsuariosPendentePorChave[cChave]) {
      return oEstado.oBuscaTicketsUsuariosPendentePorChave[cChave]
    }

    const nGeracao = oEstado.nGeracaoCache
    const oPromessa = api
      .get("/dashboard/ticketsUsers", {
        params: { initialDate: cInicial, finalDate: cFinal, companyId: nCompanyId },
      })
      .then(({ data }) => {
        if (get().nGeracaoCache !== nGeracao) {
          return { data: [] }
        }
        set((oAtual) => ({
          oTicketsUsuariosPorChave: { ...oAtual.oTicketsUsuariosPorChave, [cChave]: data },
          lTicketsUsuariosInvalido: false,
          oBuscaTicketsUsuariosPendentePorChave: removerChavePendente(
            oAtual.oBuscaTicketsUsuariosPendentePorChave,
            cChave,
          ),
        }))
        return data
      })
      .catch((oErro) => {
        if (get().nGeracaoCache === nGeracao) {
          set((oAtual) => ({
            oBuscaTicketsUsuariosPendentePorChave: removerChavePendente(
              oAtual.oBuscaTicketsUsuariosPendentePorChave,
              cChave,
            ),
          }))
        }
        throw oErro
      })

    set((oAtual) => ({
      oBuscaTicketsUsuariosPendentePorChave: { ...oAtual.oBuscaTicketsUsuariosPendentePorChave, [cChave]: oPromessa },
    }))
    return oPromessa
  },

  ticketsUsuariosObter: async (oParametros) => get().ticketsUsuariosBuscar(oParametros),

  ticketsDiaBuscar: async ({
    initialDate: cInicial,
    finalDate: cFinal,
    companyId: nCompanyId,
    force: lForcar = false,
  } = {}) => {
    const cChave = dashboardTicketsPeriodoChaveGerar(cInicial, cFinal, nCompanyId)
    const oEstado = get()

    if (!lForcar && !oEstado.lTicketsDiaInvalido && oEstado.oTicketsDiaPorChave[cChave]) {
      return oEstado.oTicketsDiaPorChave[cChave]
    }

    if (oEstado.oBuscaTicketsDiaPendentePorChave[cChave]) {
      return oEstado.oBuscaTicketsDiaPendentePorChave[cChave]
    }

    const nGeracao = oEstado.nGeracaoCache
    const oPromessa = api
      .get("/dashboard/ticketsDay", {
        params: { initialDate: cInicial, finalDate: cFinal, companyId: nCompanyId },
      })
      .then(({ data }) => {
        if (get().nGeracaoCache !== nGeracao) {
          return { data: [], count: 0 }
        }
        set((oAtual) => ({
          oTicketsDiaPorChave: { ...oAtual.oTicketsDiaPorChave, [cChave]: data },
          lTicketsDiaInvalido: false,
          oBuscaTicketsDiaPendentePorChave: removerChavePendente(oAtual.oBuscaTicketsDiaPendentePorChave, cChave),
        }))
        return data
      })
      .catch((oErro) => {
        if (get().nGeracaoCache === nGeracao) {
          set((oAtual) => ({
            oBuscaTicketsDiaPendentePorChave: removerChavePendente(oAtual.oBuscaTicketsDiaPendentePorChave, cChave),
          }))
        }
        throw oErro
      })

    set((oAtual) => ({
      oBuscaTicketsDiaPendentePorChave: { ...oAtual.oBuscaTicketsDiaPendentePorChave, [cChave]: oPromessa },
    }))
    return oPromessa
  },

  ticketsDiaObter: async (oParametros) => get().ticketsDiaBuscar(oParametros),

  periodoCompletoBuscar: async ({
    date_from: cDateFrom,
    date_to: cDateTo,
    days: nDays,
    companyId: nCompanyId,
    force: lForcar = false,
  } = {}) => {
    const [oPrincipal, oTicketsUsuarios, oTicketsDia] = await Promise.all([
      get().principalBuscar({ date_from: cDateFrom, date_to: cDateTo, days: nDays, force: lForcar }),
      get().ticketsUsuariosBuscar({
        initialDate: cDateFrom,
        finalDate: cDateTo,
        companyId: nCompanyId,
        force: lForcar,
      }),
      get().ticketsDiaBuscar({ initialDate: cDateFrom, finalDate: cDateTo, companyId: nCompanyId, force: lForcar }),
    ])

    return { oPrincipal, oTicketsUsuarios, oTicketsDia }
  },
}))

export { dashboardPeriodoChaveGerar, dashboardTicketsPeriodoChaveGerar }
